(function () {
  var INQUIRY_SENT_URL = '/?sections=inquiry-sent';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle('overflow-hidden', on);
  }

  function cleanUrl(raw) {
    var u = String(raw || '').trim().replace(/^["']+|["']+$/g, '');
    if (!u) return '';
    if (!/^https?:\/\//i.test(u)) u = u.indexOf('//') === 0 ? 'https:' + u : 'https://' + u;
    return u;
  }

  function shopDomainPdfUrl(url) {
    var u = cleanUrl(url);
    if (!u) return u;
    if (u.indexOf('/cdn/shop/files/') !== -1 && u.indexOf(window.location.host) !== -1) return u;
    var filePart = '';
    if (u.indexOf('/cdn/shop/files/') !== -1) filePart = u.split('/cdn/shop/files/').pop();
    else if (u.indexOf('/files/') !== -1) filePart = u.split('/files/').pop();
    if (!filePart) return u;
    return window.location.origin + '/cdn/shop/files/' + filePart;
  }

  function themeAssetUrl(filename) {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].src;
      if (src && /product-pdf-(preview|hub)\.js/i.test(src)) {
        return src.replace(/product-pdf-(preview|hub)\.js.*/, filename);
      }
    }
    return null;
  }

  function loadPdfJsScript() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    var pdfSrc = themeAssetUrl('pdf.min.js');
    if (!pdfSrc) return Promise.reject(new Error('pdf.min.js path missing'));
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = pdfSrc;
      script.async = true;
      script.onload = function () {
        if (!window.pdfjsLib) {
          reject(new Error('PDF.js unavailable'));
          return;
        }
        var workerSrc = themeAssetUrl('pdf.worker.min.js');
        if (workerSrc) window.pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
        resolve(window.pdfjsLib);
      };
      script.onerror = function () {
        reject(new Error('PDF.js load error'));
      };
      document.head.appendChild(script);
    });
  }

  function waitForPdfJs() {
    return loadPdfJsScript();
  }

  function fetchPdfBytes(url) {
    return fetch(url, { mode: 'cors', credentials: 'omit', cache: 'default' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.arrayBuffer();
      })
      .catch(function () {
        return new Promise(function (resolve, reject) {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.responseType = 'arraybuffer';
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.response);
            else reject(new Error('XHR ' + xhr.status));
          };
          xhr.onerror = function () {
            reject(new Error('XHR network'));
          };
          xhr.send();
        });
      });
  }

  function waitLayout(el) {
    return new Promise(function (resolve) {
      function step() {
        var w = el.clientWidth || (el.parentElement && el.parentElement.clientWidth) || 0;
        if (w > 60) {
          resolve(w);
          return;
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  function getWorkerSrc(root) {
    return root.dataset.pdfjsWorker || root.dataset.pdfjsWorker || '';
  }

  function renderPdf(root, url, canvasWrap) {
    var worker = getWorkerSrc(root);
    var loadUrl = shopDomainPdfUrl(url);
    return waitForPdfJs()
      .then(function (pdfjs) {
        if (worker) pdfjs.GlobalWorkerOptions.workerSrc = worker;
        return fetchPdfBytes(loadUrl).catch(function () {
          return fetchPdfBytes(url);
        }).then(function (buffer) {
          return pdfjs.getDocument({ data: buffer }).promise;
        });
      })
      .then(function (pdf) {
        return waitLayout(canvasWrap).then(function (maxW) {
          canvasWrap.innerHTML = '';
          var chain = Promise.resolve();
          for (var p = 1; p <= pdf.numPages; p += 1) {
            (function (pageNum) {
              chain = chain.then(function () {
                return pdf.getPage(pageNum).then(function (page) {
                  var base = page.getViewport({ scale: 1 });
                  var scale = Math.min(1.8, Math.max(0.5, (maxW - 24) / base.width));
                  var vp = page.getViewport({ scale: scale });
                  var canvas = document.createElement('canvas');
                  canvas.className = 'pdf-hub__page-canvas';
                  canvas.width = vp.width;
                  canvas.height = vp.height;
                  return page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise.then(function () {
                    canvasWrap.appendChild(canvas);
                  });
                });
              });
            })(p);
          }
          return chain;
        });
      });
  }

  function initRfq(root) {
    var form = qs('#PdfRfqContactForm', root);
    var iframe = qs('[data-pdf-rfq-iframe]', root);
    if (!form || !iframe) return;

    var loadingEl = qs('[data-pdf-rfq-loading]', root);
    var successEl = qs('[data-pdf-rfq-success]', root);
    var errorEl = qs('[data-pdf-rfq-error]', root);
    var msgField = qs('[data-pdf-rfq-message]', root);
    var submitting = false;

    function rfqState(state, text) {
      if (loadingEl) loadingEl.hidden = state !== 'loading';
      if (successEl) successEl.hidden = state !== 'success';
      if (errorEl) {
        errorEl.hidden = state !== 'error';
        if (text) errorEl.textContent = text;
      }
    }

    function warmIframe() {
      if (!iframe.getAttribute('src')) iframe.setAttribute('src', INQUIRY_SENT_URL);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;
      submitting = true;
      rfqState('loading');

      var body = form.elements['contact[body]'] || qs('[data-pdf-rfq-body]', root);
      if (body) {
        body.value = [
          'RFQ from PDF viewer',
          'Product: ' + (root.dataset.productTitle || ''),
          'URL: ' + (root.dataset.productUrl || ''),
          'SKU: ' + (root.dataset.productSku || ''),
          'Name: ' + (form.elements['contact[name]'] && form.elements['contact[name]'].value),
          'Email: ' + (form.elements['contact[email]'] && form.elements['contact[email]'].value),
          'Phone: ' + (form.elements['contact[phone]'] && form.elements['contact[phone]'].value),
          '',
          msgField ? msgField.value : ''
        ].join('\n');
      }

      warmIframe();
      form.setAttribute('target', iframe.getAttribute('name'));
      form.submit();
      window.setTimeout(function () {
        rfqState('success');
        form.reset();
        submitting = false;
        form.removeAttribute('target');
      }, 2500);
    });

    warmIframe();
  }

  function resolveElements(root) {
    var dialog = qs('[data-pdf-dialog]', root);
    var openBtn = qs('[data-pdf-open]', root);
    var closeBtn = qs('[data-pdf-close]', root);
    var loadingEl = qs('[data-pdf-loading]', root);
    var canvasWrap = qs('[data-pdf-canvas]', root);
    var fallbackEl = qs('[data-pdf-fallback]', root) || qs('[data-pdf-viewer-fallback]', root);
    var legacyIframe = qs('[data-pdf-viewer-iframe]', root) || qs('[data-pdf-viewer]', root);
    var legacyObject = qs('[data-pdf-object]', root);

    if (!canvasWrap) {
      var wrap = qs('[data-pdf-viewer-wrap]', root);
      if (wrap) {
        canvasWrap = document.createElement('div');
        canvasWrap.className = 'pdf-hub__canvas-wrap';
        canvasWrap.setAttribute('data-pdf-canvas', '');
        canvasWrap.hidden = true;
        wrap.appendChild(canvasWrap);
      }
    }

    return {
      dialog: dialog,
      openBtn: openBtn,
      closeBtn: closeBtn,
      loadingEl: loadingEl,
      canvasWrap: canvasWrap,
      fallbackEl: fallbackEl,
      legacyIframe: legacyIframe,
      legacyObject: legacyObject
    };
  }

  function applyCanonicalPdfUrls(root, url) {
    var canon = shopDomainPdfUrl(url);
    root.dataset.pdfUrl = canon;
    root.querySelectorAll('a[href]').forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      if (href.indexOf('cdn.shopify.com') !== -1 && href.indexOf('/files/') !== -1) {
        anchor.setAttribute('href', canon);
      }
    });
    var alt = document.querySelector('link[rel="alternate"][type="application/pdf"]');
    if (alt) alt.setAttribute('href', canon);
    return canon;
  }

  function initHub(root) {
    var url = cleanUrl(root.dataset.pdfUrl);
    if (!url) return;
    url = applyCanonicalPdfUrls(root, url);

    var ui = resolveElements(root);
    if (!ui.dialog || !ui.openBtn || !ui.canvasWrap) return;

    var busy = false;

    function hideLegacy() {
      if (ui.legacyIframe) ui.legacyIframe.hidden = true;
      if (ui.legacyObject) ui.legacyObject.hidden = true;
    }

    function showLoading() {
      if (ui.loadingEl) ui.loadingEl.hidden = false;
      if (ui.canvasWrap) ui.canvasWrap.hidden = true;
      if (ui.fallbackEl) ui.fallbackEl.hidden = true;
      hideLegacy();
    }

    function showCanvas() {
      if (ui.loadingEl) ui.loadingEl.hidden = true;
      if (ui.fallbackEl) ui.fallbackEl.hidden = true;
      hideLegacy();
      if (ui.canvasWrap) ui.canvasWrap.hidden = false;
    }

    function showFallback() {
      if (ui.loadingEl) ui.loadingEl.hidden = true;
      if (ui.canvasWrap) ui.canvasWrap.hidden = true;
      hideLegacy();
      if (ui.fallbackEl) {
        ui.fallbackEl.hidden = false;
        if (!ui.fallbackEl.textContent.trim()) {
          ui.fallbackEl.innerHTML =
            '预览加载失败，请 <a href="' +
            url +
            '" target="_blank" rel="noopener noreferrer">点击新标签页打开 PDF</a>';
        }
      }
    }

    function loadPdf() {
      if (busy) return;
      busy = true;
      showLoading();
      renderPdf(root, url, ui.canvasWrap)
        .then(function () {
          busy = false;
          showCanvas();
        })
        .catch(function () {
          busy = false;
          showFallback();
        });
    }

    function open() {
      if (!ui.dialog.showModal) {
        window.open(shopDomainPdfUrl(url), '_blank', 'noopener,noreferrer');
        return;
      }
      ui.dialog.showModal();
      lockScroll(true);
      loadPdf();
    }

    function close() {
      if (!ui.dialog.open) return;
      ui.dialog.close();
      lockScroll(false);
    }

    ui.openBtn.addEventListener('click', open);
    ui.closeBtn && ui.closeBtn.addEventListener('click', close);
    ui.dialog.addEventListener('click', function (e) {
      if (e.target === ui.dialog) close();
    });
    ui.dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    initRfq(root);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-pdf-hub], [data-pdf-preview]');
    nodes.forEach(initHub);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
